import { useState } from "react";
import "./editorialForms.css";

export default function RestaurantForm({ data, onChange }) {
  const [menuItemInput, setMenuItemInput] = useState("");

  const cuisineTypes = [
    "Brasileira",
    "Italiana",
    "Japonesa",
    "Chinesa",
    "Mexicana",
    "Árabe",
    "Francesa",
    "Americana",
    "Indiana",
    "Tailandesa",
    "Portuguesa",
    "Vegana",
    "Vegetariana",
    "Fast Food",
    "Pizzaria",
    "Churrascaria",
    "Frutos do Mar",
    "Confeitaria",
    "Outro",
  ];

  const priceRanges = [
    { id: "$", name: "Econômico ($)" },
    { id: "$$", name: "Moderado ($$)" },
    { id: "$$$", name: "Sofisticado ($$$)" },
    { id: "$$$$", name: "Luxo ($$$$)" },
  ];

  const handleAddMenuItem = () => {
    if (menuItemInput.trim()) {
      onChange({
        ...data,
        menuItems: [
          ...(data?.menuItems || []),
          { name: menuItemInput.trim(), price: 0 },
        ],
      });
      setMenuItemInput("");
    }
  };

  const handleRemoveMenuItem = (index) => {
    onChange({
      ...data,
      menuItems: (data?.menuItems || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form restaurant_form">
      <div className="editorial_form_section">
        <label>
          Nome do Restaurante <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Restaurante Sabor & Arte"
          value={data?.name || ""}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Fale sobre o restaurante, especialidades, ambiente..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Cozinha</label>
          <select
            value={data?.cuisineType || ""}
            onChange={(e) => onChange({ ...data, cuisineType: e.target.value })}
          >
            <option value="">Selecione</option>
            {cuisineTypes.map((cuisine) => (
              <option key={cuisine} value={cuisine}>
                {cuisine}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Faixa de Preço</label>
          <select
            value={data?.priceRange || "$$"}
            onChange={(e) => onChange({ ...data, priceRange: e.target.value })}
          >
            {priceRanges.map((range) => (
              <option key={range.id} value={range.id}>
                {range.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Endereço</label>
        <input
          type="text"
          placeholder="Rua, número, bairro, cidade"
          value={data?.address || ""}
          onChange={(e) => onChange({ ...data, address: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Telefone</label>
          <input
            type="tel"
            placeholder="(11) 99999-9999"
            value={data?.phone || ""}
            onChange={(e) => onChange({ ...data, phone: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>WhatsApp</label>
          <input
            type="tel"
            placeholder="(11) 99999-9999"
            value={data?.whatsapp || ""}
            onChange={(e) => onChange({ ...data, whatsapp: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Horário de Funcionamento</label>
          <input
            type="text"
            placeholder="Ex: Seg-Sex 11h-23h, Sáb-Dom 12h-00h"
            value={data?.openingHours || ""}
            onChange={(e) => onChange({ ...data, openingHours: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Avaliação (1-5)</label>
          <input
            type="number"
            min="1"
            max="5"
            step="0.1"
            placeholder="4.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Itens do Cardápio
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddMenuItem}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Nome do prato..."
          value={menuItemInput}
          onChange={(e) => setMenuItemInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddMenuItem()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.menuItems || []).map((item, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveMenuItem(i)}
              style={{ cursor: "pointer" }}
            >
              {item.name} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Serviços</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasDelivery"
              checked={data?.hasDelivery || false}
              onChange={(e) =>
                onChange({ ...data, hasDelivery: e.target.checked })
              }
            />
            <label htmlFor="hasDelivery">Delivery</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasReservation"
              checked={data?.hasReservation || false}
              onChange={(e) =>
                onChange({ ...data, hasReservation: e.target.checked })
              }
            />
            <label htmlFor="hasReservation">Reservas</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasTakeout"
              checked={data?.hasTakeout || false}
              onChange={(e) =>
                onChange({ ...data, hasTakeout: e.target.checked })
              }
            />
            <label htmlFor="hasTakeout">Retirada</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="hasParking"
              checked={data?.hasParking || false}
              onChange={(e) =>
                onChange({ ...data, hasParking: e.target.checked })
              }
            />
            <label htmlFor="hasParking">Estacionamento</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="acceptsCard"
              checked={data?.acceptsCard !== false}
              onChange={(e) =>
                onChange({ ...data, acceptsCard: e.target.checked })
              }
            />
            <label htmlFor="acceptsCard">Aceita cartão</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip restaurant_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z" />
        </svg>
        <span>
          Divulgue seu restaurante com cardápio, horários e serviços.
          Atraia novos clientes.
        </span>
      </div>
    </div>
  );
}
